import React, { useState, useEffect } from "react";
import "./AccordionsList.scss";

import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const AccordionsList = ({ items }) => {
  const [expanded, setExpanded] = useState([]);

  useEffect(() => {
    setExpanded(items.map((_, index) => `panel${index}`));
  }, [items]);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded((prevExpanded) =>
      isExpanded
        ? [...prevExpanded, panel]
        : prevExpanded.filter((p) => p !== panel)
    );
  };

  return (
    <div className="accordions-list">
      {items.map((item, index) => {
        return (
          <Accordion
            expanded={expanded.includes(`panel${index}`)}
            onChange={handleChange(`panel${index}`)}
            className="mb-3"
            style={{
              background: "#FBFBFB",
            }}
            key={index}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel${index}bh-content`}
              id={`panel${index}bh-header`}
            >
              <Typography className="accordion-title">
                <b>{item.title}</b>
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                className="accordion-desc"
                dangerouslySetInnerHTML={{ __html: item.description }}
              ></Typography>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </div>
  );
};

export default AccordionsList;
